<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style lang="scss">
$gray: #e6ddcc;
$pink: #e24a9b;
$white: #ffffff;

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}

body,
h1, h2, h3, h4, h5, h6, p,
ul, li,
.row {
  margin: 0px;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue